
import 'react-dadata/dist/react-dadata.css';

import CargoPageContent from '@features/market/cargo/Cargo.FormPageContent';

export default function CargoAddPage() {
    return <CargoPageContent />;
}
